import React, { useEffect, useState } from "react";
import { Modal, Icon, Button, message, Popover } from "antd";
import { useWatchState } from "@/store";
import { BaseService, WXService } from "@/service";
import { checkResult } from "@/common";

const NAME = "pushConfirm";

const View = () => {

    const [[props, setProps], [ROOT]] = useWatchState(["modal." + NAME, "ROOT"])
    const { title = "确认推送", show, hide, pushId, pushGroupId, type, appid, pushTitle, pushTitleParams, pushRemark, callback } = props;
    const name = { result: "成果", demand: "需求" }[type];
    const table = { result: "thtt_chengguo", demand: "thtt_xuqiu" }[type];
    const key = { result: "chengguo_id", demand: "xuqiu_id" }[type];

    var [data, setData] = useState([]);
    var [data2, setData2] = useState([]);
    const [items, setItems] = useState([]);

    const getPushOrgs = push_id => {
        BaseService.list({
            table: "thtt_push_wechat_orgs",
            where: { push_id },
            leftJoin: JSON.stringify([
                {
                    table: "thtt_organization",
                    on: "thtt_push_wechat_orgs.org_id = thtt_organization.organization_id",
                    columns: JSON.stringify(["name AS orgName"])
                },
                {
                    table: "thtt_user",
                    on: "thtt_organization.user_id = thtt_user.user_id",
                    columns: JSON.stringify(["openid", "name AS userName", "tel AS userTel"])
                },
            ])
        }).then(res => {
            if (!checkResult(res)) return;
            setData(res.data.result);
        })
    }

    const getItems = (pushWechatId) => {
        BaseService.list({
            table: "thtt_push_group_items",
            leftJoin: JSON.stringify([
                {
                    table,
                    on: `thtt_push_group_items.item_id = ${table}.${key}`,
                    columns: JSON.stringify(["name", "profile"])
                },
                {
                    table: "thtt_organization",
                    on: `thtt_organization.organization_id = ${table}.unit`,
                    columns: JSON.stringify(["profile AS orgProfile"])
                },
            ]),
            process: {
                name: "scopes",
                key: "item_id",
                targetKey: key,
                params: {
                    table: table + "_scope",
                    columns: "second_scope_id",
                    leftJoin: {
                        table: "thtt_scope",
                        on: table + "_scope.second_scope_id = thtt_scope.id",
                        columns: JSON.stringify(["name AS scopeName"])
                    }
                }
            },
            where: { push_wechat_ids: pushWechatId }
        }).then(res => {
            if (!checkResult(res)) return;
            setItems(res.data.result);
        })
    }

    useEffect(() => {
        if (pushId) {
            data = []
            setData([]);
            setData2([]);
            getPushOrgs(pushId);
            getItems(pushId);
        }
    }, [pushId])

    const checkFinish = async () => {
        const noPush = data.find(({ push_status }) => push_status === 0)

        const pushFinishId = items.map(({ id }) => id);
        const pushFinishDemandId = items.map(({ item_id }) => item_id);

        // 修改 thtt_push_group_items 表推送状态
        const putRes = await BaseService.put({
            table: "thtt_push_group_items",
            data: { push_state: 2, push_time: new Date().format("yyyy-MM-dd hh:mm:ss") },
            where: {
                id: JSON.stringify(pushFinishId)
            }
        })
        if (!checkResult(putRes)) return;

        // 修改 thtt_xuqiu 表推送状态
        const putDRes = await BaseService.put({
            table: "thtt_xuqiu",
            data: { is_pushed: 1 },
            where: {
                xuqiu_id: JSON.stringify(pushFinishDemandId)
            }
        })
        if (!checkResult(putDRes)) return;

        if (!noPush) BaseService.put({
            table: "thtt_push_wechat",
            data: { push_status: 1, push_time: new Date().format("yyyy-MM-dd hh:mm:ss") },
            where: { id: pushId }
        }).then(res => {
            if (!checkResult(res)) return;
            if (callback) callback();
        })
    }

    const finish = async () => {
        const sendData = data.filter(({ push_status }) => push_status === 0);
        for (let vo of sendData) {
            const { openid, id, org_id } = vo;
            const _id = id;
            const errmsg = await onSend(openid, id, org_id)
            if (errmsg !== "ok") return message.error(errmsg);
            const putRes = await BaseService.put({
                table: "thtt_push_wechat_orgs",
                where: { id },
                data: { push_status: 1 }
            })
            if (!checkResult(putRes)) return;
            data.find(({ id }, i) => {
                if (id === _id) {
                    data[i].push_status = 1;
                    return true;
                }
            })
            setData([...data]);
            message.success("发送成功！");
        }

        const sendData2 = data2.filter(({ push_status }) => push_status === 0);
        for (let vo of sendData2) {
            const { openid, id, org_id } = vo;
            const _id = id;
            const errmsg = await onSend(openid, id, org_id)
            if (errmsg !== "ok") return message.error(errmsg);
            data2.find(({ id }, i) => {
                if (id === _id) {
                    data2[i].push_status = 1;
                    return true;
                }
            })
            setData2([...data2]);
            message.success("发送成功！");
        }
        checkFinish();
    }
    const onSend = async (openid, push_org_id, org_id) => {
        const url = `${ROOT}?jump=wxPushDetail/${pushId}/${type}/${org_id}/${pushGroupId}/#/wx`;
        const res = await WXService.sendTemplateMsg({
            touser: openid,
            template_id: "HBXdW_XIfp_Nz64ijFYui7Y6up70jat_3jN-5WKYxYs",
            url,
            appid,
            data: {
                "first": {
                    "value": `${pushTitleParams}${pushTitle ? " - " + pushTitle : ""}`,
                    "color": "#173177"
                },
                "keynote1": {
                    "value": "已完成",
                    "color": "#173177"
                },
                "keynote2": {
                    "value": new Date().format("yyyy-MM-dd hh:mm:ss"),
                    "color": "#173177"
                },
                "remark": {
                    "value": pushRemark,
                    "color": "#173177"
                }
            }
        })

        const errmsg = res.data.result.errmsg || res.data.result.msg;
        return errmsg
    }

    console.log(data2)

    return (
        <Modal
            title={title}
            visible={show}
            width="80vw"
            maskClosable={false}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left-sm">
                    <Button type="primary" onClick={finish}>推送</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <div className="flex child-left-md">
                <div className="shrink-0" style={{ width: "200px" }}>
                    <p className="bold font-size-16">{name}推送主题：</p>
                    <span className="font-size-14 dark-disable">{pushTitleParams}{pushTitle && ` - ${pushTitle}`}</span>
                    <p className="bold font-size-16 self-top-sm">{name}来源介绍：</p>
                    <span className="font-size-14 dark-disable">{pushRemark}</span>
                </div>
                <div className="full child-top-sm">
                    <p className="bold font-size-18">{name}列表</p>
                    {items.map(vo => (
                        <div className="flex space child-left-sm">
                            <span style={{ width: "50%" }} className="font-size-16 nowrap--ellipsis">{vo.name}</span>
                            <span className="font-size-12">{vo.scopes.map(({ scopeName }) => scopeName).join(" ")}</span>
                            <Popover content={(
                                <div className="child-top-sm" style={{ width: "300px" }}>
                                    <div className="flex child-left-md">
                                        <p className="child-left--mini"><Icon type="user" /><span>{vo.contacts}</span></p>
                                        <p className="child-left--mini"><Icon type="phone" /><span>{vo.contacts_tel}</span></p>
                                    </div>
                                    <p className="font-size-18 bold">{name}简介</p>
                                    <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.profile }} />
                                    <p className="font-size-18 bold">机构简介</p>
                                    <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.orgProfile }} />
                                </div>
                            )} title={vo.name} trigger="click">
                                <Icon type="info-circle" />
                            </Popover>
                        </div>
                    ))}
                </div>
                <div className="shrink-0 child-top-sm" style={{ width: "400px" }}>
                    <p className="bold font-size-18">机构列表</p>
                    {data2.map(({ id, orgName, userName, userTel, openid, push_status }, i) => (
                        <div className="flex child-left-sm">
                            {push_status === 1 && <Icon type="check" style={{ color: "green" }} />}
                            <p className="font-size-16 nowrap--ellipsis">{orgName}</p>
                            {/* <p className="child-left--mini">{openid && <Icon type="wechat" style={{ color: "#65b257" }} />}<span>{userName}</span></p>
                            <p>{userTel}</p> */}
                        </div>
                    ))}
                    {data.map(({ id, orgName, userName, userTel, openid, push_status }, i) => (
                        <div className="flex child-left-sm">
                            {push_status === 1 && <Icon type="check" style={{ color: "green" }} />}
                            <p className="font-size-16 nowrap--ellipsis">{orgName}</p>
                            {/* <p className="child-left--mini">{openid && <Icon type="wechat" style={{ color: "#65b257" }} />}<span>{userName}</span></p>
                            <p>{userTel}</p> */}
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
}

export default View;